import React from 'react'

import { SearchContextProps } from './types'

export const SearchContextV2 = React.createContext({} as SearchContextProps)
